import * as mutation from "./mutation-types";
import * as action from "./action-types";
import { GLOBAL_ERROR } from "@/store/system/mutation-types";
import { deepCopyAxiosException } from "@/store/helpers";
import { tableHelper } from "@/helpers/table.helper";
import axios from "axios";

export const actions = {
  async [action.VIEW]({ commit }, key) {
    commit(mutation.VIEW_STARTED, key);
    try {
      const url = `/api/levy-estimator/${key}`;
      const { data } = await axios.get(url);
      commit(mutation.VIEW_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.VIEW_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.VIEW_REFRESH]({ state, dispatch }, key) {
    const needsRefreshed = (!state.estimator.loaded && !state.estimator.loading) || state.estimator.key != key;
    if (needsRefreshed) {
      await dispatch(action.VIEW, key);
    }
  },

  async [action.PUBLIC_ESTIMATOR_GET]({ commit }, { type, year }) {
    commit(mutation.PUBLIC_ESTIMATOR_GET_STARTED, { type, year });
    try {
      const url = tableHelper.constructUrl(`/api/public-levy-estimator/${type}/${year}`);
      const { data } = await axios.get(url);
      commit(mutation.PUBLIC_ESTIMATOR_GET_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PUBLIC_ESTIMATOR_GET_FAILED, deepCopyAxiosException(e));
      return false;
    }
  },
  async [action.PUBLIC_ESTIMATOR_CALCULATE]({ commit, state }) {
    commit(mutation.PUBLIC_ESTIMATOR_CALCULATE_STARTED);
    try {
      const s = state.publicEstimator;
      const url = tableHelper.constructUrl(`/api/public-levy-estimator/${s.type}/${s.year}/calculation`, s.edit);
      const { data } = await axios.get(url);
      commit(mutation.PUBLIC_ESTIMATOR_CALCULATE_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PUBLIC_ESTIMATOR_CALCULATE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  },

  async [action.PLAYGROUND_CALCULATE]({ commit, state }, key) {
    commit(mutation.PLAYGROUND_CALCULATE_STARTED, key);
    try {
      const url = tableHelper.constructUrl(`/api/levy-estimator/${key}/playground`, state.playground.parameters);
      const { data } = await axios.get(url);
      commit(mutation.PLAYGROUND_CALCULATE_SUCCEEDED, data);
      return true;
    } catch (e) {
      commit(mutation.PLAYGROUND_CALCULATE_FAILED);
      commit(GLOBAL_ERROR, deepCopyAxiosException(e));
      return false;
    }
  }
};
